import '.hq{max-width:240px;}.ssr-plugin'
import { useEffect, useState } from 'react'
import { TextInput } from '../TextInput/index.js'
import { IconButton } from '../IconButton/index.js'
import { useThrottledDistinctCallback } from '../../hooks/useThrottledDistinctCallback.js'
import { styled } from 'inlines'

export type SearchInputProps = {
  value?: string
  onChange: (value: string) => void
  disabled?: boolean
  throttleDelay?: number
}

export const SearchInput = ({
  value: valueProp,
  onChange,
  disabled,
  throttleDelay,
}: SearchInputProps) => {
  const [open, setOpen] = useState(false)
  const [value, setValue] = useState(valueProp)
  const throttle = useThrottledDistinctCallback(throttleDelay || 500)

  useEffect(() => setValue(valueProp), [valueProp])

  useEffect(() => {
    if (valueProp !== undefined) {
      setOpen(true)
    }
  }, [valueProp])

  if (open) {
    return (
      <div className="hq"
      >
        <TextInput
          autoFocus
          value={value}
          placeholder="Filter results..."
          leadIcon="search"
          onChange={(search) => {
            if (onChange) {
              throttle(search, (value) => {
                onChange(value as string)
              })
            }
            setValue(search)
          }}
          onBlur={(e) => {
            if (!e.target.value) {
              setOpen(false)
            }
          }}
        />
      </div>
    )
  }

  return (
    <IconButton
      tooltip="Find in results"
      keyHint="Cmd+K"
      disabled={disabled}
      icon="search"
      onClick={() => {
        setOpen(true)
      }}
    />
  )
}
